/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _sortBy from 'lodash.sortby';
import Component from '@glimmer/component';

import NotificationModel from 'cio/models/notification';

interface FeatureListArgs {
  features: NotificationModel[];
}

export default class FeatureList extends Component<FeatureListArgs> {
  get sortedFeatures() {
    return _sortBy(this.args.features, ['activated']).reverse();
  }
}
